// extracted by mini-css-extract-plugin
export default {"container":"PageChangeAnimation_container__boHMR","shadow":"PageChangeAnimation_shadow__Z2Uz2"};